// extracted by mini-css-extract-plugin
export default {"to-previous-step":"ToPreviousStepButton_to-previous-step__NjBcs"};